const initialState = {
  calls: [],
};

const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CALLS_LOADED":
      state = {
        calls: action.payload.calls,
      };
      break;
    default:
      break;
  }
  return state;
};

export default historyReducer;



// WEBPACK FOOTER //
// ./src/reducers/historyReducer.js